
import dagre from 'dagre';
import { AppNode } from '../types';
// Fix: Use named imports for Edge and Position from reactflow.
import { Edge, Position } from 'reactflow';

// Default node dimensions for layout calculation
const NODE_WIDTH = 220; // Slightly wider than visual width to ensure spacing
const NODE_HEIGHT = 100; // Slightly taller

export const getLayoutedElements = (
  nodes: AppNode[],
  edges: Edge[],
  direction: 'TB' | 'LR' = 'LR'
): AppNode[] => {
  const dagreGraph = new dagre.graphlib.Graph();
  dagreGraph.setDefaultEdgeLabel(() => ({}));

  const isHorizontal = direction === 'LR';
  dagreGraph.setGraph({ rankdir: direction });

  // Filter out nodes that have a parent (e.g. boundary events attached to tasks)
  // We only want to layout top-level nodes.
  const nodesToLayout = nodes.filter(node => !node.parentNode);

  nodesToLayout.forEach((node) => {
    // Check if it's a boundary event (smaller size)
    // Even if it's top level (detached), treat as smaller
    const isBoundary = node.type?.endsWith('BoundaryEvent');
    const width = isBoundary ? 60 : NODE_WIDTH;
    const height = isBoundary ? 60 : NODE_HEIGHT;

    dagreGraph.setNode(node.id, { width, height });
  });

  // Add edges to dagre only if both source and target are in the layout set
  edges.forEach((edge) => {
    const sourceInLayout = nodesToLayout.find(n => n.id === edge.source);
    const targetInLayout = nodesToLayout.find(n => n.id === edge.target);
    
    if (sourceInLayout && targetInLayout) {
        dagreGraph.setEdge(edge.source, edge.target);
    }
  });

  // Calculate layout
  dagre.layout(dagreGraph);

  // Return nodes with new positions
  return nodes.map((node) => {
    // If node was not in layout (e.g. it has a parent), skip modifying it
    if (node.parentNode) return node;

    const nodeWithPosition = dagreGraph.node(node.id);
    
    // We are shifting the dagre node position (anchor=center center) to the top left
    // so it matches React Flow's anchor point (top left).
    const width = nodeWithPosition.width;
    const height = nodeWithPosition.height;
    
    return {
      ...node,
      targetPosition: isHorizontal ? Position.Left : Position.Top,
      sourcePosition: isHorizontal ? Position.Right : Position.Bottom,
      position: {
        x: nodeWithPosition.x - width / 2,
        y: nodeWithPosition.y - height / 2,
      },
    };
  });
};
